import type {ReactElement} from 'react';
import React from 'react';
import type {BaseContextualMenuGridPanelProps} from './base-contextual-menu-grid-panel.types';
import {DEFAULT_ITEMS_PER_ROW} from './base-contextual-menu-grid-panel.types';
import styles from './base-contextual-menu-grid-panel.module.scss';
import {BaseContextualMenuGridItem} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-contextual-menu-grid-panel/components/base-contextual-menu-grid-item/base-contextual-menu-grid-item';
import {noop} from '@Utils/general.util';

export function BaseContextualMenuGridPanel({
  isLoading = false,
  showNameWithThumb = false,
  itemsPerRow = DEFAULT_ITEMS_PER_ROW,
  onSelected = noop,
  hasCustomDimensions = false,
  containerClass = '',
  hasBorder = true,
  ...props
}: BaseContextualMenuGridPanelProps): ReactElement {
  const getItemContainerClass = (index: number): string | undefined => {
    if (!containerClass) {
      return;
    }
    if (hasNextRowSubOptions(index)) {
      return containerClass;
    }
    return containerClass + ' spacing-m-b-5';
  };

  const hasNextRowSubOptions = (index: number): boolean => {
    if (!props.subOptionToShow) {
      return false;
    }
    const currentItemRowIndex = Math.floor(index / itemsPerRow);
    const items = [...props.items];

    const allItemsInCurrentRow = items.slice(currentItemRowIndex * itemsPerRow, currentItemRowIndex * itemsPerRow + itemsPerRow);

    for (const itemInCurrentRow of allItemsInCurrentRow) {
      if (itemInCurrentRow.id === props.selectedId) {
        return true;
      }
    }
    return false;
  };

  const shouldShowSubOptionsNext = (index: number): boolean => {
    const position = index + 1;
    if (position % 3 !== 0 && position !== props.items.length) {
      return false;
    }
    return hasNextRowSubOptions(index);
  };

  return (
    <div className={`flexbox flex-align-items-center ${hasCustomDimensions ? styles.fixedDimensions : '_full-width spacing-p-l-5 spacing-p-r-5'} ${styles.thumbsContainer}`}>
      {props.items.map((item, index) => {
        return (
          <BaseContextualMenuGridItem
            key={item.id}
            id={item.id}
            thumb={item.thumb}
            isLoading={isLoading}
            onSelected={onSelected}
            hasBorder={hasBorder}
            subOptionToShow={props.subOptionToShow}
            hasSubOptions={props.hasSubOptions}
            isSelected={props.selectedId === item.id}
            hasCustomDimensions={hasCustomDimensions}
            containerClass={getItemContainerClass(index)}
            text={showNameWithThumb ? item.name : undefined}
            shouldShowSubOptionsNext={shouldShowSubOptionsNext(index)}
          />
        );
      })}
    </div>
  );
}
